import { Main } from './content.styles';

interface ModalContentProps extends React.HTMLProps<HTMLDivElement> {
  padding?: string;
}

export const ModalContent = ({ children, padding, ...otherProps }: ModalContentProps) => (
  <>
    <Main {...otherProps} padding={padding}>
      {children}
    </Main>
  </>
);
